<kendo-dialog *ngIf="showDialog" title="Add Bit" [minWidth]="500" [width]="760" (close)="cancel()">
  <form [formGroup]="form" class="k-form">
    <div class="dialog-grid">
      <div class="dialog-field">
        <label>Request ID *</label>
        <kendo-numerictextbox formControlName="requestTargetId" [spinners]="false" ></kendo-numerictextbox>
      </div>
      <div class="dialog-field">
        <label>Bit Type *</label>
        <kendo-textbox formControlName="bitType" placeholder="Type"></kendo-textbox>
      </div>
      <div class="dialog-field">
        <label>Bit Level</label>
        <kendo-numerictextbox formControlName="bitLevel" [spinners]="false"></kendo-numerictextbox>
      </div>
      <div class="dialog-field">
        <label>Product Line *</label>
        <kendo-numerictextbox formControlName="bit_Productline" [spinners]="false"></kendo-numerictextbox>
      </div>
      <div class="dialog-field">
        <label>Sub PSL *</label>
        <kendo-numerictextbox formControlName="bit_SubPsl" [spinners]="false"></kendo-numerictextbox>
      </div>
      <div class="dialog-field">
        <label>Size *</label>
        <kendo-numerictextbox formControlName="size" [spinners]="false"></kendo-numerictextbox>
      </div>
      <div class="dialog-field">
        <label>Core Size *</label>
        <kendo-numerictextbox formControlName="coreSize" [spinners]="false"></kendo-numerictextbox>
      </div>
      <div class="dialog-field">
        <label>Material Weight</label>
        <kendo-textbox formControlName="materialWeight"></kendo-textbox>
      </div>
      <div class="dialog-field">
        <label>MFG Plant</label>
        <kendo-textbox formControlName="mfgPlant"></kendo-textbox>
      </div>
      <div class="dialog-field checkbox-field">
        <kendo-switch formControlName="hasSleeve"></kendo-switch>
        <label>Has Sleeve</label>
      </div>
      <div class="dialog-field checkbox-field">
        <kendo-switch formControlName="isJV"></kendo-switch>
        <label>Is JV</label>
      </div>
    </div>
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancel()" [disabled]="submitting">Cancel</button>
    <button kendoButton themeColor="primary" (click)="submit()" [disabled]="form.invalid || submitting">
      Add Bit
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
